import React from "react";
import PropTypes from "prop-types";

import "./page-header.scss";
import InfoPanel from "../utils/InfoPanel";
import Breadcrumbs from "../utils/Breadcrumbs";

function PageHeaderNavigation({ breadcrumbs, infoPanelLinks }) {
  return (
    <div className="page-header-navigation">
      <div className="page-header_breadcrumbs">
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
        {infoPanelLinks && <InfoPanel links={infoPanelLinks} />}
      </div>
    </div>
  );
}

PageHeaderNavigation.defaultProps = {
  breadcrumbs: null,
  infoPanelLinks: null,
};

PageHeaderNavigation.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
  infoPanelLinks: PropTypes.objectOf(PropTypes.string),
};
export default PageHeaderNavigation;
